// extracted by mini-css-extract-plugin
module.exports = {"form":"FormComment_form__2JxHA","textarea":"FormComment_textarea__2dlhS","button":"FormComment_button__8jfiH","woof":"FormComment_woof__3wGqR"};